export class Review {

	reviewId: number;
	action: string;
	responseDesc: any;
	responseDescFlag: boolean;
	guestFollowupRequest?: boolean;
	yelpReviewRequest?: boolean;
}
